// Auto-generated from octomil-contracts. Do not edit.

export enum CompatibilityLevel {
  Stable = "stable",
  Beta = "beta",
  Experimental = "experimental",
  Compatibility = "compatibility",
}
